import mobileAppAllComponent from './mobile_app.all.component';

let mobileAppAllModule = angular.module('mobileAppAll', [
])

    .component('mobileAppAll', mobileAppAllComponent)

    .name;

export default mobileAppAllModule;    


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/all/index.js